import { COLLECTIONS } from "constants/action-types";

export interface IAddItem {
    itemsId: string;
    addType?: string;
    attributes?: any;
    index?: number;
    productId?: string;
    rowId?: string;
    skipScroll?: boolean;
    collectionId?: string;
    selected?: boolean;
}

export interface IMutateCollectionItemPayload {
    itemsId: string;
    index: number;
    item: any;
    value?: string;
    meta?: {};
    fieldName?: string;
}

export const mutateCollectionItem = (payload: IMutateCollectionItemPayload) => ({
    payload,
    type: COLLECTIONS.COLLECTION.ITEMS.ITEM.MUTATE,
});
